import React from 'react';
import { Modal } from 'antd';

import DF from 'DisplayFramework';
import ParameterDetail from 'pages/Configuration/Management/ParameterDetails';

type ParamListModalProps = {
  onCancel: () => void;
  parcode: string;
  visible: boolean;
  title: React.ReactNode | string;
  onSuccess?: () => void;
};

const ParamListModal = (props: ParamListModalProps) => {
  const { onCancel, parcode, visible, title } = props;

  return (
    (<DF.Provider pagcode="contract">
      <Modal
        open={visible}
        onCancel={onCancel}
        width={1400}
        title={title}
        footer={null}
      >
        <ParameterDetail parcode={parcode} />
      </Modal>
    </DF.Provider>)
  );
};

export default ParamListModal;
